export enum MassMailInquiryType {
  Visi = 'visi',
  Daudzbērnu = 'daudzbērnu',
  Invaliditāte = 'invaliditāte',
}
